module.exports = __webpack_public_path__ + "static/media/select_logo_image.f874efd8.png";